import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class LabelColumnWidthBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.labelColumnWidth = {
            init: (node: HTMLElement) => {
                let element = $(node);
                let caption = element.find('> .c-caption');

                caption.addClass('c-labelcolumn');
            },
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let value = valueAccessor();
                let width = ko.unwrap(value);
                let caption = element.find('> .c-caption');

                if (caption.length && caption.text().length) {
                    caption.css('flex-basis', width);
                }
            }
        };
    }
}